var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2643_23999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08539 6.07916C6.71491 5.89392 6.2644 6.04409 6.07916 6.41457C5.89392 6.78505 6.04409 7.23556 6.41457 7.4208L8.07293 8.24998L6.41457 9.07916C6.04409 9.2644 5.89392 9.71491 6.07916 10.0854C6.2644 10.4559 6.71491 10.606 7.08539 10.4208L10.0854 8.9208C10.3395 8.79376 10.5 8.53406 10.5 8.24998C10.5 7.9659 10.3395 7.7062 10.0854 7.57916L7.08539 6.07916Z",
    fill: "#061240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9146 6.07916C17.2851 5.89392 17.7356 6.04409 17.9208 6.41457C18.1061 6.78505 17.9559 7.23556 17.5854 7.4208L15.9271 8.24998L17.5854 9.07916C17.9559 9.2644 18.1061 9.71491 17.9208 10.0854C17.7356 10.4559 17.2851 10.606 16.9146 10.4208L13.9146 8.9208C13.6605 8.79376 13.5 8.53406 13.5 8.24998C13.5 7.9659 13.6605 7.7062 13.9146 7.57916L16.9146 6.07916Z",
    fill: "#061240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12C4.5 12 4.5 19.5 12 19.5C19.5 19.5 19.5 12 19.5 12H4.5Z",
    fill: "#061240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57257 4.06707C5.48475 1.99064 8.3214 0.75 11.9992 0.75C15.6769 0.75 18.5136 1.99064 20.4258 4.06707C22.3286 6.13339 23.2483 8.95333 23.2483 11.9992C23.2483 15.045 22.3286 17.8649 20.4258 19.9313C18.5136 22.0077 15.6769 23.2483 11.9992 23.2483C8.3214 23.2483 5.48475 22.0077 3.57257 19.9313C1.6697 17.8649 0.75 15.045 0.75 11.9992C0.75 8.95333 1.6697 6.13339 3.57257 4.06707ZM4.67597 5.08319C3.07946 6.81683 2.25 9.24647 2.25 11.9992C2.25 14.7519 3.07946 17.1815 4.67597 18.9151C6.26316 20.6387 8.67609 21.7483 11.9992 21.7483C15.3222 21.7483 17.7352 20.6387 19.3224 18.9151C20.9189 17.1815 21.7483 14.7519 21.7483 11.9992C21.7483 9.24647 20.9189 6.81683 19.3224 5.08319C17.7352 3.35967 15.3222 2.25 11.9992 2.25C8.67609 2.25 6.26316 3.35967 4.67597 5.08319Z",
    fill: "#061240"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2643_23999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunny);
export default __webpack_public_path__ + "static/media/funny.dfac04fc.svg";
export { ForwardRef as ReactComponent };